define('modules/start/products/sms/logobutton/view',['require','exports','module','env','../../base/logobutton/view'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseLogobuttonView = require("../../base/logobutton/view");

    var Layout = BaseLogobuttonView.extend({
        privateUrl: Config.mdirectorPrivateUrl,
        defaultDomain: Config.defaultDomain,
        serviceName: 'mdirector',
        logoName:'sms'
    });

    module.exports = Layout;
});

